(function () {
    'use strict';

    angular
        .module('app')
        .factory('AuthenticationService', AuthenticationService);

    AuthenticationService.$inject = ['$http', '$rootScope', '$timeout', 'UserService', 'ApiService', '$window', '$location', '$stateParams', '$state'];
    function AuthenticationService($http, $rootScope, $timeout, UserService, ApiService, $window, $location, $stateParams, $state) {
        var service = {};

        service.Login = Login;
        service.Logout = Logout;
        service.ValidateEmailForReset = ValidateEmailForReset;
        service.ResetPassword = ResetPassword;
        service.CreatePassword = CreatePassword;
        service.LoginToken = LoginToken;
        service.SetCredentials = SetCredentials;
        service.ClearCredentials = ClearCredentials;

        return service;

        function Login(Email, Password, RememberMe, callback) {

            var response;
            ApiService.post('/API/accountAPI/GetLogIn', { Email: Email, Password: Password, RememberMe: RememberMe })
                            .then(
                            function (response) {
                                if (response.data.UserId != 0) {
                                    SetCredentials(response.data);
                                    $rootScope.LogInFailed = false;                                    
                                }
                                else {
                                    ClearCredentials();
                                    $rootScope.LogInFailed = true;
                                }
                                callback(response);
                            },
                            function (response) {
                                ClearCredentials();
                                $rootScope.LogInFailed = true;
                                callback(response);
                            }
                            );
        }

        function ValidateEmailForReset(email, lang, emailTitle, callback) {

            var response;
            ApiService.post('/API/accountAPI/ValidateEmailForReset?email=' + email + '&lang=' + lang + "&emailTitle="+ emailTitle)
                            .then(function (response) {
                                callback(response);
                            }, function (response) {
                                callback(response);
                            });
        }

        function ResetPassword(user, callback) {
            var response;
            var st = JSON.stringify(user);
            ApiService.post('/API/accountAPI/ResetPassword', st)
                
                            .then(function (response) {
                                callback(response);
                            }, function (response) {
                                callback(response);
                            });
        }

        function CreatePassword(user, lang, emailTitle, callback) {
            var response;
            var st = JSON.stringify(user);
            ApiService.post('/API/accountAPI/CreatePassword?lang=' + lang + "&emailTitle="+ emailTitle, st)

                            .then(function (response) {
                                callback(response);
                            }, function (response) {
                                callback(response);
                            });
        }

        function LoginToken(Email, Password, callback) {
            //$timeout(function () {
            //    var response;
            //    UserService.Login(username)
            //        .then(function (user) {
            //            alert("Logged in : " + user.Password);
            //            console.log(user);
            //            if (user !== null && user.Password === password) {
            //                response = { success: true };

            //            } else {
            //                response = { success: false, message: 'Username or password is incorrect' };
            //            }
            //            callback(response);
            //        });
            //}, 1000);

            /* Use this for real authentication
             ----------------------------------------------*/
            //return $http.get('/API/userAPI/getuser/1').then(handleSuccess, handleError('Error getting user by username'));

            $http.post('/API/userAPI/PostLoginToken', { Email: Email, Password: Password })
                .success(function (response) {
                    callback(response);
                });

        }

        function SetCredentials(user) {
            var authdata = Base64.encode(user.UserId + ':' + user.RoleId);

            $rootScope.globals = {
                currentUser: {
                    UserId: user.UserId,
                    RememberMe: user.RememberMe,
                    RoleId: user.RoleId,
                    ZoneIdList: user.ZoneIdList,
                    FullName: user.FullName,
                    Email: user.Email,
                    LangForInterface: user.LangForInterface,
                    LangForWork: user.LangForWork,
                    LangForTranslationSource: user.LangForTranslationSource,
                    LangForTranslationDestination: user.LangForTranslationDestination,
                    SessionId: user.SessionId,
                    AppVersion: appVersion,
                    AuthenData: user.AuthenData
                },
                expiryTime: Math.round(new Date().getTime() / 1000 + $rootScope.expiryDurationInSecond)
            };

            // set default auth header for http requests            
            $http.defaults.headers.common['Authorization'] = user.AuthenData;

            //store user details in local storage
            $window.localStorage.globals = JSON.stringify($rootScope.globals);            
        }

        function ClearCredentials() {
            $rootScope.globals = null;            
            delete $window.localStorage.globals

            $http.defaults.headers.common.Authorization = 'Basic';            
            //$location.path('/login');
        }

        function Logout() {
            $rootScope.returnUrlAfterLogin = null;
            $location.search({});
            $location.path('/login');
        }
    }

    // Base64 encoding service used by AuthenticationService
    var Base64 = {

        keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

        encode: function (input) {
            var output = "";
            var chr1, chr2, chr3 = "";
            var enc1, enc2, enc3, enc4 = "";
            var i = 0;

            do {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    this.keyStr.charAt(enc1) +
                    this.keyStr.charAt(enc2) +
                    this.keyStr.charAt(enc3) +
                    this.keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
            } while (i < input.length);

            return output;
        },

        decode: function (input) {
            var output = "";
            var chr1, chr2, chr3 = "";
            var enc1, enc2, enc3, enc4 = "";
            var i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            var base64test = /[^A-Za-z0-9\+\/\=]/g;
            if (base64test.exec(input)) {
                window.alert("There were invalid base64 characters in the input text.\n" +
                    "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
                    "Expect errors in decoding.");
            }
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

            do {
                enc1 = this.keyStr.indexOf(input.charAt(i++));
                enc2 = this.keyStr.indexOf(input.charAt(i++));
                enc3 = this.keyStr.indexOf(input.charAt(i++));
                enc4 = this.keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";

            } while (i < input.length);

            return output;
        }
    };
    
})();